<template>
  <div>
    <div class="col">
      <div>
        <b-form-datepicker size="sm" @context="handleDateSelected($event)" v-model="p_date" class="mb-1"
          today-button close-button locale="zh" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"></b-form-datepicker>
      </div>
      
      <div>
        <b-table 
          striped 
          hover 
          sticky-header="1200px" 
          :small="true" 
          :busy="isBusy" 
          :items="stocks" 
          :fields="fields">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>加载中...</strong>
            </div>
          </template>
          <!-- 自定义列格式 -->
          <template #cell(px_change_rate)="data">
            <div :style="getPercentStyle(data.value)">{{ data.value }}</div>
          </template>
          <template #cell(rank_diff)="data">
            <div :style="getPercentStyle(data.value)">{{ data.value }}</div>
          </template>
          <template #cell(stock_name)="data">
            <div @click="p_show_kline(data.item.stock_code, data.value)">{{ data.value }}</div>
          </template>
          <template #cell(stock_code)="data">
            <div @click="p_show_kline(data.value, data.item.stock_name)">{{ data.value }}</div>
          </template>
        </b-table>
      </div>
      <div class="mb-2 text-right">
        <b-button-group size="sm">
          <b-button variant="outline-primary" @click="exportStocks('csv')">导出CSV</b-button>
          <b-button variant="outline-success" @click="exportStocks('xlsx')">导出EXCEL</b-button>
        </b-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from "network/request.js"
import * as XLSX from 'xlsx'

export default {
  props: {
    plate_type: Number,
    plate_code: String,
    p_date: String,
  },
  data() {
    return {
      isBusy: true,
      stocks: [],
      fields: [
        {
          key: 'rank',
          label: '排名',
          sortable: true
        },
        {
          key: 'rank_diff',
          label: '变化',
          sortable: true,
        },
        {
          key: 'stock_name',
          label: '名称',
          sortable: true,
        },
        {
          key: 'stock_code',
          label: '代码',
          sortable: true,
        },
        {
          key: 'px_change_rate',
          label: '涨幅',
          sortable: true,
        }
      ]
    };
  },
  mounted() {
    this.refresh_popular();
  },
  watch: {
    plate_code(newPlateCode, oldPlateCode) {
      if (newPlateCode !== oldPlateCode) {
        this.refresh_popular();
      }
    },
    p_date(newDate, oldDate) {
      if (newDate !== oldDate) {
        this.refresh_popular();
      }
    }
  },
  methods: {
    p_show_kline(stock_code, stock_name) {
      this.$emit('p_show_kline', stock_code, stock_name)
    },
    exportFileName() {
      const datePart = this.p_date || ''
      const codePart = this.plate_code || 'plate'
      return `stocks_${codePart}_${datePart}`
    },
    exportStocks(format) {
      if (!Array.isArray(this.stocks) || this.stocks.length === 0) {
        return
      }
      const headers = this.fields.map(f => f.label)
      const keys = this.fields.map(f => f.key)
      const rows = this.stocks.map(item => {
        const row = {}
        keys.forEach((k, idx) => {
          row[headers[idx]] = item[k]
        })
        return row
      })
      const filename = this.exportFileName()
      if (format === 'xlsx') {
        const ws = XLSX.utils.json_to_sheet(rows, { header: headers })
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'stocks')
        const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([out], { type: 'application/octet-stream' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${filename}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        return
      }
      const csvHeader = headers.join(',')
      const csvBody = this.stocks.map(item => keys.map(k => {
        const val = item[k]
        const s = val === null || val === undefined ? '' : String(val)
        return '"' + s.replace(/"/g, '""') + '"'
      }).join(',')).join('\n')
      const csv = '\ufeff' + csvHeader + '\n' + csvBody
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${filename}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    refresh_popular() {
      this.isBusy = true;
      request_zzquant({
        url: '/market/plates/'+this.plate_type+'/' + this.plate_code + '/stocks/rank?is_real=1&limit=100&date1=' + this.p_date
      })
      .then(res1 => {
        this.stocks = res1['data']['data'];
        this.isBusy = false;
      })
      .catch(err => {
        console.log(err);
        this.isBusy = false;
      });
    },
    handleDateSelected(event) {
      this.$emit('date-selected', event.selectedYMD);
    },
    getGradientColor(startColor, endColor, percent) {
      // 去掉开头的 # 如果有的话
      startColor = startColor.replace(/^\s*#|\s*$/g, '');
      endColor = endColor.replace(/^\s*#|\s*$/g, '');
    
      // 将3位颜色代码转换为6位，例如 `E0F` --> `EE00FF`
      if (startColor.length == 3) {
        startColor = startColor.replace(/(.)/g, '$1$1');
      }
    
      if (endColor.length == 3) {
        endColor = endColor.replace(/(.)/g, '$1$1');
      }
    
      // 获取颜色
      function parse(rgb, i) {
        return parseInt(rgb.substr(i, 2), 16)
      }
    
      let startR = parse(startColor, 0),
          startG = parse(startColor, 2),
          startB = parse(startColor, 4);
    
      let endR = parse(endColor, 0),
          endG = parse(endColor, 2),
          endB = parse(endColor, 4);
    
      // 计算新颜色
      let r = endR - startR;
      let g = endG - startG;
      let b = endB - startB;
    
      r = ((r * percent) + startR)
      g = ((g * percent) + startG)
      b = ((b * percent) + startB)
    
      function hex(x) {
        let h = x.toString(16).split('.')[0].toUpperCase()
        return (h.length == 1) ? '0' + h : h
      }
    
      return '#' + hex(r) + hex(g) + hex(b)
    },
    getPercentColor(pt) {
      if (pt >= 0) {
        if (pt > +10) {
          pt = +10;
        }
        pt = +pt / 10;
        return this.getGradientColor('#FFFFFF', '#FB1023', pt)
      } else {
        if (pt < -10) {
          pt = -10;
        }
        pt = -pt / 10;
        return this.getGradientColor('#FFFFFF', '#278B22', pt)
      }
    },
    getPercentStyle(pt) {
      return {
        'background': this.getPercentColor(pt)
      }
    },
  }
};
</script>

<style scoped>
.table td {
  cursor: pointer;
}
</style>
